import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import FullWidthWrapper from '../FullWidthWrapper';
import CardItem from './CardItem';
import List from '../List';
import { getParams } from '../utils';

import styles from '../links.less';

const Cards = (mainProps) => {
  const { RecordSelect, sceneId, canExpandWidth, canExpandWidthAndHeight, config, ...props } = mainProps;
  
  // expanded mode:
  // 1 in section or tab
  // has no multiselect
  // has now multiselect previously (has many items from past time)
  // const multiselect = config && config.get('multiselect');
  const expanded = ( canExpandWidth || canExpandWidthAndHeight );// && ( ! multiselect) && ( props.items && props.items.length <=1 );
  
  const extendedItems = props.items.filter(item => {
    if (!item) {
      return;
    }

    const itemData = item.get('item');
    const canRestore = item.get('canRestore');
    const removed = itemData && itemData.get('isRemoved');

    const params = getParams(item, props.controlConfig, props.remoteGroup);
    const extendedFields = params && params.catalogId && props.extendedFields.get(params.catalogId);

    return extendedFields && !removed && !canRestore;
  });
  const simpleItems = props.items.filter(item => {
    if (!item) {
      return;
    }

    const itemData = item.get('item');
    const canRestore = item.get('canRestore');
    const removed = itemData && itemData.get('isRemoved');

    const params = getParams(item, props.controlConfig, props.remoteGroup);
    const extendedFields = params && params.catalogId && props.extendedFields.get(params.catalogId);

    return ! (extendedFields && !removed && !canRestore );
  });

  return (
    <FullWidthWrapper
      className={styles.cards}
      fullWidth={expanded}
    >
      {
      // items with extended fields
      extendedItems.map((item) => {
        const itemRemovableProperty = item.getIn(['item', 'removable']);
        const itemData = item.get('item');
        const removed = itemData && itemData.get('isRemoved');

        const params = getParams(item, props.controlConfig, props.remoteGroup, props.parent);
        const extendedFields = params && params.catalogId && props.extendedFields.get(params.catalogId);

        const removable = itemRemovableProperty === false ? itemRemovableProperty : !props.readOnly && !props.apiOnly;

        return (
          <CardItem
            sceneId={sceneId}
            key={item.get('key')}
            item={item}
            extFields={extendedFields}
            params={params}
            removed={removed}
            readOnly={props.readOnly}
            removable={removable}
            compact={!expanded}
            onRemoveItem={() => props.onRemoveItem && props.onRemoveItem(item)}
          />
        );
      })}

      {
      // removed & deleted items
      simpleItems.size ? (
        <List
          sceneId={sceneId}
          parent={props.parent}
          controlConfig={props.controlConfig}
          items={simpleItems}
          readOnly={props.readOnly}
          onRemoveItem={props.onRemoveItem}
        />
      ): null}
      {RecordSelect ? <RecordSelect.type additionalItems={props.additionalItems} {...RecordSelect.props} /> : null}
    </FullWidthWrapper>
  );
};

Cards.propTypes = {
  items: PropTypes.object,
  editable: PropTypes.bool,
  readOnly: PropTypes.bool,
  params: PropTypes.object,
  onClickItem: PropTypes.func,
  onRemoveItem: PropTypes.func,
};

export default Cards;
